import { ActivityIndicator, View } from "@-/com.npmjs.react-native";

/**
 * The "more below" affordance at the bottom of an incrementally rendered deck section: a small
 * spinner that sits under the last revealed row until the section has revealed every card (and
 * their details have loaded). Reaching it via scroll is what reveals the next batch.
 */
export function DeckCardSectionLoadingFooter() {
  return (
    <View
      accessibilityLabel="Loading more cards"
      className="items-center justify-center py-3"
      testID="deck-card-section-loading-footer"
    >
      <ActivityIndicator size="small" />
    </View>
  );
}
